import { elementType, shape, string } from 'prop-types';

export default shape({
  component: elementType.isRequired,
  to: string,
});
